/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/button-has-type */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { Checkbox, IconButton, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import { LoadingButton } from '@mui/lab';
import { SearchBox } from '../shared/SharedComponents';

const PAGE_SIZE = 10;

// ── useDebounce ───────────────────────────────────────────────────────────────
function useDebounce(value, delay = 400) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}

// ── Mini pagination ───────────────────────────────────────────────────────────
const ModalPagination = ({ page, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;
  return (
    <div className="flex items-center justify-between px-6 py-2 border-t border-gray-100 bg-gray-50">
      <span className="text-[12px] text-gray-400">Page {page} of {totalPages}</span>
      <div className="flex items-center gap-1">
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page === 1}
          className="px-3 py-1 rounded-[6px] text-[12px] font-medium border border-gray-200 bg-white text-gray-600 cursor-pointer hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed"
        >
          ‹ Prev
        </button>
        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page === totalPages}
          className="px-3 py-1 rounded-[6px] text-[12px] font-medium border border-gray-200 bg-white text-gray-600 cursor-pointer hover:bg-gray-100 disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Next ›
        </button>
      </div>
    </div>
  );
};

const AddCourseModal = ({
  open,
  onClose,
  onAdd,
  existingIds = [],
  fetchFn,
  singleSelect = false,
  audienceFilter = ['B2C', 'BOTH'],
  planIsFree = false,
  usedCourseIds = [],
  subscriptionTypeCode = ''
}) => {
  const [search, setSearch]     = useState('');
  const [list, setList]         = useState([]);
  const [total, setTotal]       = useState(0);
  const [page, setPage]         = useState(1);
  const [loading, setLoading]   = useState(false);
  const [selected, setSelected] = useState([]);
  const [adding, setAdding]     = useState(false);

  const debouncedSearch = useDebounce(search);
  const totalPages = Math.ceil(total / PAGE_SIZE);

  // Reset everything when modal opens
  useEffect(() => {
    if (open) {
      setSelected([]);
      setSearch('');
      setPage(1);
    }
  }, [open]);

  // Fetch whenever page or debounced search changes (while open)
  useEffect(() => {
    if (open) fetchList(page, debouncedSearch);
  }, [open, page, debouncedSearch]);

  // Reset to page 1 when search changes
  useEffect(() => {
    setPage(1);
  }, [debouncedSearch]);

const fetchList = async (pageNum = 1, searchVal = '') => {
  setLoading(true);

  try {
    if (fetchFn) {
      const res = await fetchFn({
        page: pageNum,
        pageSize: PAGE_SIZE,
        search: searchVal,
      });

      if (res?.ok) {
        const filtered = (res?.data || []).filter((item) => item?.status === 1);
        setList(filtered);
        // setTotal(filtered.length);
        // setList(res?.data || []);
        setTotal(res?.total || 0);
      }
    }
  } catch (e) {
    console.error('[AddCourseModal fetchList]', e);
  }

  setLoading(false);
};


const existingSet = new Set((existingIds || []).map(id => String(id)));
const audienceSet = new Set((audienceFilter || []).map(a => String(a).toUpperCase()));

const available = list.filter((c) => {
  const code = subscriptionTypeCode?.toUpperCase();
  if (code === 'B2B') return true;  
  const isFree = c.isFree === true ||  c.isFree === 'true';
  return planIsFree ? isFree : !isFree;
});

//   const available = (list || []).filter((c) => {
//   const code = (c?.audienceCode || '').toUpperCase();

//   const audienceOk =
//     audienceFilter?.length
//       ? audienceFilter.map((a) => a.toUpperCase()).includes(code)
//       : true;

//   const freeOk = planIsFree ? c?.isFree === true : !c?.isFree;

//   return (
//     !existingIds?.includes(c?.id) &&
//     !usedCourseIds?.includes(c?.id) &&
//     freeOk &&
//     c?.status === 1 &&
//     audienceOk
//   );
// });

  const toggle = (id) => {
    if (existingSet.has(String(id))) return;
    setSelected((prev) =>
      singleSelect
        ? prev.includes(id) ? [] : [id]
        : prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const handleAdd = async () => {
    setAdding(true);
    await onAdd(selected);
    setAdding(false);
    onClose();
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[1300] flex items-center justify-center bg-black/35">
      <div className="bg-white rounded-xl w-[480px] max-h-[90vh] flex flex-col border border-gray-200">

        {/* Header */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100">
          <p className="text-[15px] font-bold text-gray-900">Add Course</p>
          <IconButton size="small" onClick={onClose} sx={{ color: '#6b7280' }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>

        {/* Search */}
        <div className="px-6 pt-4 pb-2">
          <SearchBox
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search courses..."
          />
        </div>

        {/* List */}
        <div className="flex-1 overflow-y-auto px-6 pb-2">
          {loading ? (
            <div className="flex justify-center py-10">
              <CircularProgress size={20} sx={{ color: '#2563eb' }} />
            </div>
          ) : available.length === 0 ? (
            <div className="flex flex-col items-center py-10 gap-2 text-gray-400">
              <InboxOutlinedIcon sx={{ fontSize: '28px', color: '#d1d5db' }} />
              <p className="text-[13px]">
                {search ? 'No courses match your search' : 'No courses available.'}
              </p>
            </div>
          ) : (
            available.map((c, idx) => {
              const isExisting = existingSet.has(String(c.id));
              const isChecked  = isExisting || selected.includes(c.id);

              return (
                <div
                  key={c.id}
                  role="button"
                  tabIndex={isExisting ? -1 : 0}
                  onClick={() => !isExisting && toggle(c.id)}
                  onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && !isExisting && toggle(c.id)}
                  className={`flex items-center py-[10px] rounded px-1 ${
                    isExisting
                      ? 'opacity-50 cursor-not-allowed'
                      : 'hover:bg-gray-50 cursor-pointer'
                  }`}
                  style={{ borderBottom: idx < available.length - 1 ? '1px solid #f3f4f6' : 'none' }}
                >
                  <Checkbox
                    size="small"
                    checked={isChecked}
                    disabled={isExisting}
                    onClick={(e) => e.stopPropagation()}
                    onChange={() => toggle(c.id)}
                    sx={{
                      p: '4px', mr: '10px',
                      color: '#d1d5db',
                      '&.Mui-checked':   { color: isExisting ? '#9ca3af' : '#2563eb' },
                      '&.Mui-disabled':  { color: '#9ca3af' },
                    }}
                    icon={singleSelect
                      ? <span style={{ width: 18, height: 18, borderRadius: '50%', border: '2px solid #d1d5db', display: 'inline-block' }} />
                      : undefined}
                    checkedIcon={singleSelect
                      ? <span style={{ width: 18, height: 18, borderRadius: '50%', border: `2px solid ${isExisting ? '#9ca3af' : '#2563eb'}`, background: isExisting ? '#9ca3af' : '#2563eb', display: 'inline-block' }} />
                      : undefined}
                  />
                  <div>
                    <div className="flex items-center gap-2">
                    <p className="text-[13px] font-medium text-gray-900">{c.title}</p>
                      {isExisting && (
                        <span className="text-[10px] font-medium text-gray-400 bg-gray-100 px-[6px] py-[2px] rounded-full">
                          Already added
                        </span>
                      )}
                    </div>
                    <p className="text-[11px] text-gray-400 uppercase tracking-[0.04em]">
                      {c.type || c.courseType || 'VIDEO'}
                      {c.isIndividuallySold && (
                        <span className="text-amber-500 ml-[6px]">· Also sold individually</span>
                      )}
                    </p>
                  </div>
                </div>
              );
            })
          )}
        </div>

        {/* Pagination */}
        <ModalPagination page={page} totalPages={totalPages} onPageChange={setPage} />

        {/* Footer */}
        <div className="flex items-center justify-between px-6 py-4 border-t border-gray-100">
          <p className="text-[13px] text-gray-500">
            {selected.length} selected
            {total > 0 && <span className="ml-2 text-gray-400">· {total} total</span>}
          </p>
          <div className="flex gap-[10px]">
            <button
              onClick={onClose}
              className="bg-transparent border border-gray-300 rounded-[7px] px-4 py-2 text-[13px] text-gray-700 cursor-pointer hover:bg-gray-50"
            >
              Cancel
            </button>
            <LoadingButton
              loading={adding}
              variant="contained"
              onClick={handleAdd}
              disabled={selected.length === 0}
              sx={{
                background: '#2563eb', borderRadius: '7px', textTransform: 'none',
                fontSize: '13px', fontWeight: 600, px: '20px',
                '&:hover': { background: '#1d4ed8' },
              }}
            >
              Add Selected
            </LoadingButton>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AddCourseModal;